import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "react-toastify/dist/ReactToastify.css";
import reportWebVitals from "./reportWebVitals";
import { sendToVercelAnalytics } from "./vitals";
import store from "./Store/store";
import { Provider } from 'react-redux';
import { NotificationProvider } from "./Context/Notifications";

ReactDOM.render(
  <React.StrictMode>
      <NotificationProvider>
    <Provider store={store}>
      <App />
    </Provider>
      </NotificationProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals(sendToVercelAnalytics);
